import Backbone from 'backbone';
import moment from 'moment';

import DateFormatter from 'utils/date/DateFormatter';

import Pregnancysnapshot from 'models/user/periodichealth/Pregnancysnapshot';

let Pregnancysnapshots = Backbone.Collection.extend({
    model: Pregnancysnapshot,
    backend: 'gcapi',

    url() {
        return '/periodichealth-service/menstrualcycle/pregnancysnapshot/all';
    },

    comparator(snapShot) {
        return -moment(snapShot.get('dueDate'), DateFormatter.LINK_FORMAT).unix();
    },

    filterPastPregnancies() {
        return new Backbone.Collection(
            this.filter((model) => {
                return model.get('deliveryDate') !== null || model.get('endDate') !== null;
            })
        );
    },

    getActivePregnancy() {
        let active = this.filter((model) => {
            return model.get('deliveryDate') === null && model.get('endDate') === null;
        });

        let snapShot = null;

        if (active.length > 0) {
            snapShot = active[0];
            snapShot.setOriginalDueDate(active[0].get('originalDueDate'));
            snapShot.isReady = true;
        }

        return snapShot;
    }
});

export default Pregnancysnapshots;
